// frontend/src/context/AuthContext.js
import React, { createContext, useState, useEffect } from "react";
import axios from "axios";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [userInfo, setUserInfo] = useState(null);
  const [authLoading, setAuthLoading] = useState(true);
  const [isNewUser, setIsNewUser] = useState(false);

  useEffect(() => {
    const checkAuth = async () => {
      try {
        const res = await axios.get("/api/auth/check-auth", {
          withCredentials: true,
        });
        if (res.data.authenticated) {
          setUserInfo(res.data.user);
        } else {
          setUserInfo(null);
        }
      } catch (error) {
        setUserInfo(null);
      } finally {
        setAuthLoading(false);
      }
    };

    checkAuth();
  }, []);

  // Custom setter for userInfo that can also set the isNewUser flag
  const setUserInfoWithStatus = (userData, newUserStatus = false) => {
    setUserInfo(userData);
    setIsNewUser(newUserStatus);
  };

  return (
    <AuthContext.Provider
      value={{
        userInfo,
        setUserInfo: setUserInfoWithStatus,
        authLoading,
        isNewUser,
        setIsNewUser,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
